/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import "./style2.css";
import * as React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import FacebookIcon2 from "../../Images/icon/facebook.png";
import InstagramIcon2 from "../../Images/icon/insta.png";
import YouTubeIcon2 from '../../Images/icon/youtube.png';
import ContactsIcon from '@mui/icons-material/Contacts';
import logo from "../../Images/logo.png";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import HomeIcon from '@mui/icons-material/Home';
import { Button, ThemeProvider, createTheme } from "@mui/material";
import Badge from "@mui/material/Badge";
import { Icons } from "../../Data/cardData";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -5,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));
const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
  palette: {
    primary: {
       
           main: "#fff",
      light: "#80cbc4",
      dark: "#00695c",
      contrastText: "#fff",
      
    },
 
  },
});

function Header2() {
  const [isOpen2, setIsOpen2] = useState(false);
   const [scrolling, setScrolling] = useState(false);
  const menuRef = useRef(null); // Référence au menu
  useEffect(() => {
    const handleScroll = () => setScrolling(window.scrollY >= 90);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const toggleMenu2 = () => {
    setIsOpen2(!isOpen2);
  };
  const handleMouseLeave = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen2(false);
    }
  };
  
  // Fonction pour fermer le menu si le clic est en dehors du menu
  useEffect(() => {
    // Ajouter un écouteur d'événements pour les mouvements de souris
    document.addEventListener("mousemove", handleMouseLeave);
  
    // Nettoyer l'écouteur d'événements à la désactivation du composant
    return () => {
      document.removeEventListener("mousemove", handleMouseLeave);
    };
  }, []);
  
  const [isOpen, setIsOpen] = useState(false);
  let navigate = useNavigate();
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };



  const cartItems = JSON.parse(localStorage.getItem("cart"));

  const cartContain = cartItems ? cartItems.length : 0;

  const [inputText, setInputText] = useState("");
  const [showList, setShowList] = useState(false);
  const textFieldRef = useRef(null);

  const inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
    setShowList(true);
  };

  const handleSearchClick = () => {
    performSearch();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      performSearch();
    }
  };

  const performSearch = () => {
    if (inputText.trim().length > 0) {
      setShowList(false);
      navigate(`/search?query=${encodeURIComponent(inputText.trim())}`);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        textFieldRef.current &&
        !textFieldRef.current.contains(event.target)
      ) {
        setShowList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const location = useLocation();
const activeLink = location.pathname.toLowerCase();

  useEffect(() => {
    const pageTitle = location.pathname.split("/").pop();
    
    if (pageTitle === "") {
      // eslint-disable-next-line no-useless-concat
      document.title = "ELLOUZE ALU";
    } else {
      document.title = `ELLOUZE ALU - ${decodeURIComponent(pageTitle).replace(/%20/g, " ")}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ThemeProvider theme={customTheme}>
      <div className="header" id="header">
    

        <div className="navbar">
          <div className="logoDiv">
            <Link to="/">
              <img src={logo} alt="logo" className="logo" />
            </Link>

            <IconButton
              sx={{
                display: {
                  lg: "none",
                  md: "none",
                  sm: "none",
                  xs: "inline-block",
                  zIndex: 990999999999999,
                },
              }}
              onClick={toggleMenu}
            >
              {!isOpen ? (
                <MenuIcon
                  id="openIcon"
                  fontSize="small"
                  sx={{
                    top: "0px",
                    right: "0px",
                     color:"white",
                  }}
                />
              ) : (
                <CloseIcon
                  id="closeIcon"
                 
                  fontSize="medium"
                  sx={{
                    top: "25px",
                    right: "20px",
 color:"white",
                    position: "fixed",
                  }}
                />
              )}
            </IconButton>
            <div id="navMenu" className={isOpen ? "linkMenu show" : "linkMenu"}>
                <div className="socialMediaIcon" style={{marginLeft:'-50px'}}>
                  <h3>Suivez-nous :</h3>
                  <a href="https://www.facebook.com/ellouzealu.tn/" target="_blank" rel="noreferrer"><img src={FacebookIcon2} alt="facebookIcon" /> </a>
                  <a href="https://www.instagram.com/ellouze_alu" target="_blank" rel="noreferrer"><img src={InstagramIcon2} alt="instagramIcon" /> </a>
                  <a href="https://www.youtube.com/@EllouzeAlu" target="_blank" rel="noreferrer"><img src={YouTubeIcon2} alt="youtubeIcon" /> </a>
                </div>
              <ol>
              
                <li>
                  <div className="iconContainer">
                    <a onClick={toggleMenu} className={`linkItems `} href="/">
                    <Button color="main" sx={{fontFamily:'Brown',fontSize:'15px'}}  endIcon={ <HomeIcon fontSize="small"/>}> Acceuil </Button>
                    </a>
                  </div>
                </li>
                <li>
                  <div className="iconContainer">
                    <a onClick={toggleMenu2} className={`linkItems `} href="#" >
                    {isOpen2?(
                    <Button color="main" sx={{fontFamily:'Brown',fontSize:'15px'}}  endIcon={ < KeyboardArrowUpIcon />}> nos produits </Button>
                    ):(
                    <Button color="main" sx={{fontFamily:'Brown',fontSize:'15px'}}  endIcon={ < KeyboardArrowDownIcon/>}> nos produits </Button>)}
                    </a>
                  </div>
                </li>
                {isOpen2 && (
                <li>
                  {Icons.map((icon, index) => (
                    <div key={index} className="iconContainer">
                      <a
                        href={`/nos-produits/${icon.nom}`}
                        target="_blank"
                        rel="noreferrer"
                        className="linkItems"
                      >
                        <span style={{fontSize:'13px'}}>{icon.nom}</span>
                      </a>
                    </div>
                  ))}
                </li>)}
                <li>
                  <div className="iconContainer">
                    <a onClick={toggleMenu} className={`linkItems `} href="/nos-realisations">
                    <Button color="main" sx={{fontFamily:'Brown',fontSize:'15px'}} > nos realisations </Button>
                    </a>
                  </div>
                </li>
                     <li>
                  <div className="iconContainer">
                    <a onClick={toggleMenu} className={`linkItems `} href="/https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2FP-01%20(1).pdf?alt=media&token=2dd101fb-0d4e-460d-8b69-3eb0a0eefb3c">
                    <Button color="main" sx={{fontFamily:'Brown',fontSize:'15px'}} > notre catalogue </Button>
                    </a>
                  </div>
                </li>
                <li>
                  <div className="iconContainer">
                    <a onClick={toggleMenu} className={`linkItems `} href="/contact">
                    <Button color="main" sx={{fontFamily:'Brown',fontSize:'15px'}} > contact </Button>
                    </a>
                  </div>
                </li>
                <li>
                  
                </li>
              </ol>
            </div>
          </div>
             <div className="navbarMiddle">
           <div className="navbarIcon">
  {icons.map((icon, index) => {
    
    const isActive =
      activeLink === icon.lien.toLowerCase() ||
      (icon.lien !== "/" && activeLink.startsWith(icon.lien.toLowerCase()));

    return (
      <div
        key={index}
        className={isActive ? "iconContainer active" : "iconContainer"}
      >
        <a href={icon.lien} rel="noreferrer">
          <span>{icon.name}</span>
        </a>
      </div>
    );
  })}
</div>

          </div>
           <div className="navbarRight">
            <a href="https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2FP-01%20(1).pdf?alt=media&token=2dd101fb-0d4e-460d-8b69-3eb0a0eefb3c" className="navbarLink">notre catalogue</a>
            <a href="tel:+21658421628" className="navbarLink">nous contacter</a>
          </div>
        </div>
         <div className={`navbarBottom ${scrolling ? 'scrolled' : ''}`}>
        <div className="navbarIcon">
        <div className="socialMediaIcon">
            <h3>Suivez-nous :</h3>
            <a href="https://www.facebook.com/ellouzealu.tn/" target="_blank" rel="noreferrer"><img src={FacebookIcon2} alt="facebookIcon" className="socialIcon" /> facebook</a>
            <a href="https://www.instagram.com/ellouze_alu" target="_blank" rel="noreferrer"><img src={InstagramIcon2} alt="instagramIcon" className="socialIcon"/> instagram</a>
            <a href="https://www.youtube.com/@EllouzeAlu" target="_blank" rel="noreferrer"><img src={YouTubeIcon2} alt="youtubeIcon" className="socialIcon" /> youtube</a>
          </div>
        </div>
       
      </div>
      </div>
   

         
     
    </ThemeProvider>
  );
}

export default Header2;

const linkMenu = [
  {
    name: "NAISSANCE", lien: "/collection/NAISSANCE", },
  { name: "CIRCONCISION", lien: "/collection/CIRCONCISION" },
  { name: "BAKLEWA", lien: "/collection/BAKLEWA" },
  { name: "BJEWIYA", lien: "/collection/BJEWIYA" },
  { name: "HLOU", lien: "/collection/HLOU" },
  { name: "BOULES", lien: "/collection/BOULES" },
  { name: "KAAK", lien: "/collection/KAAK" },
  { name: "MLABBES", lien: "/collection/MLABBES" },
  { name: "MIGNARDISE", lien: "/collection/MIGNARDISE" },
  { name: "HLOU ARBI", lien: "/collection/HLOU ARBI" },
  { name: "HLOU thé", lien: "/collection/HLOU thé" },
  { name: "sablé", lien: "/collection/sablé" },
];
const icons = [
  { name: "accueil", lien: "/" },
  { name: "nos realisations", lien: "/nos-realisations" },
  { name: "nos produits", lien: "/nos-produits" },
  { name: "contact", lien: "/contact" },
];